var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-single-slide",style:('background-image:url('+_vm.slide.image_path+')')},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"hero-slide-text"},[_c('h1',[_vm._v(_vm._s(_vm.slide.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.slide.lead))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-033a864f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SliderItem.vue
// module id = null
// module chunks = 